/**
 * 骨架屏加载组件
 * Requirements: 15.5
 */

import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * 分析结果卡片骨架屏
 */
export function AnalysisResultSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("rounded-xl border bg-white p-4", className)}>
      <div className="flex gap-4">
        <Skeleton className="h-20 w-20 rounded-lg" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-6 w-3/4" />
          <div className="flex gap-3">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    </div>
  );
}

/**
 * 准备度区域骨架屏
 */
export function ReadinessSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("space-y-4", className)}>
      <div className="flex items-center gap-6">
        <Skeleton className="h-24 w-24 rounded-full" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-28" />
        </div>
      </div>
      <Skeleton className="h-12 w-full rounded-lg" />
    </div>
  );
}

/**
 * 时间轴骨架屏
 */
export function TimelineSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("space-y-6", className)}>
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex gap-3">
          <Skeleton className="h-8 w-8 rounded-full flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-16 w-full rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}

/**
 * 完整页面骨架屏
 */
export function CarePlanPageSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("space-y-6 p-4", className)}>
      <AnalysisResultSkeleton />
      <ReadinessSkeleton />
      <TimelineSkeleton />
    </div>
  );
}

export default CarePlanPageSkeleton;
